module.exports = __webpack_public_path__ + "static/media/multilanguage.06755ca8.png";